import * as React from "react";

import { Button, ButtonProps } from "grommet";
import { Link, useNavigate } from "react-router-dom";

const LinkButton = ({ path, label, icon, ...props }) => {
    return (
        <Link to={path}>
            <Button label={label} icon={icon} {...props} />
        </Link>
    );
};

export default LinkButton;
